// AI-CONTEXT: See docs/features/participatieladder-2026-3.md
// AI-CONTEXT: See docs/pitfalls.md#dev-mirrored-constant-guarded-only-by-a-comment
//
// De participatieladder rekent met één vastgezette parameterset van de
// meetstandaard-API, nooit met `latest` (bug #118). De sets zijn
// belastingjaargebonden: ongepind zou de app op de dag dat de API een nieuwe
// set publiceert stil met andere bedragen rekenen.
//
// Alle metingen, ook oude, rekenen met deze versie (besluit D3, bevestigd
// 2026-11-02). Ophogen is dus een migratiebesluit: eerder gerapporteerde
// bedragen veranderen. Volgorde (D7): de app moet de set al kennen, dan
// publiceert de API hem, dan pas gaat deze waarde om.
//
// Spiegel: functions/participationHelpers/participationParametersVersion.js,
// bewaakt door participationParametersVersion.parity.test.js.

export const PINNED_PARTICIPATION_PARAMETERS_VERSION = '2026.3'

const PARAMETERS_BASE_URL =
    'https://us-central1-meetstandaard-api.cloudfunctions.net/arbeidsparticipatie/api/v1/arbeidsparticipatie/parameters'

/**
 * @param {string} version - Parameterversie, bv. '2026.3'
 * @returns {string} De URL van precies die versie (404 als de API hem niet kent)
 */
export const participationParametersUrl = (version) => `${PARAMETERS_BASE_URL}/${version}`

export default PINNED_PARTICIPATION_PARAMETERS_VERSION
